import flattenDeep from "lodash/flattenDeep";
import { Route, Routes as ReactRoutes, Navigate } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";

const generateFlattenRoutes = (routes: any) => {
  if (!routes) return [];
  return flattenDeep(
    routes &&
      routes?.map(({ routes: subRoutes, ...rest }: any) => [
        rest,
        generateFlattenRoutes(subRoutes),
      ])
  );
};

export const renderRoutes = (mainRoutes: any) => {
  const Routes = ({
    isAuthorized,
  }: {
    isAuthorized: boolean;
  }) => {
    const layouts = mainRoutes?.map(
      ({ layout: Layout, routes, isPublic }: any, index: number) => (
        <Route key={index} element={<Layout />}>
          <Route element={<ProtectedRoute isAuthorized={isAuthorized} isPublic={isPublic} />}>
            {generateFlattenRoutes(routes)?.map(
              ({ element: Element, path, name, roles }: any) => {
                return Element && path && <Route key={name} element={Element} path={path} />;
              }
            )}
            {/* Root path will be handled by ProtectedRoute */}
            <Route path="/" element={null} />
          </Route>
        </Route>
      )
    );
    return <ReactRoutes>{layouts}</ReactRoutes>;
  };
  return Routes;
};
